import React, { FC } from 'react'
import { Button } from 'primereact/button'

import useText from '../../../../../common/hooks/useText'
import { Dialog } from '../../../../../common/uikit/Dialog'
import Text from '../../../../../ui/Text'

export type StatisticsHelpDialogProps = {
    visible: boolean
    onHide: () => void
}

export const StatisticsHelpDialog: FC<StatisticsHelpDialogProps> = ({ visible, onHide }) => {
    const text = useText()

    const footer = (
        <div className="flex justify-content-end">
            <Button type="button" label={text('btnCancel')} text onClick={onHide} />
        </div>
    )

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={text('btnHelp')}
            footer={footer}
            data-testid="statistics-help-dialog"
        >
            <Text code="msgStatisticsHelp" />
            <p className="mb-0">
                <Text code="msgStatisticHelpDownload" />
                <span className="inline-flex align-items-center ml-1 p-1 border-round bg-primary text-primary-color">
                    <span className="pi pi-download"></span>
                </span>
            </p>
        </Dialog>
    )
}
